var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-9.96 1.9a1.01 1.01 0 0 1-1.01-.97l-.36-7.48a1.39 1.39 0 1 1 2.78 0l-.4 7.49a1.01 1.01 0 0 1-1.01.95ZM12 18.66A1.33 1.33 0 1 0 12 16a1.33 1.33 0 0 0 0 2.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationlarge);
export default __webpack_public_path__ + "static/media/exclamation.large.9ce84af9530bfe6bb0dac18820a37398.svg";
export { ForwardRef as ReactComponent };